import axios from "axios";
// import { getStorage } from './localStorage';

import store from "@state/store";
import { SET_API_CALL_IN_PROGRESS } from "@state/rootStore";

const HTTPClient = axios.create({
  baseURL: "https://hub.automatuslab.com",
  // baseURL: "/api",
});

HTTPClient.interceptors.request.use(
  config => {
    config.headers["x-api-key"] = process.env.VUE_APP_API_KEY;
    store.commit(SET_API_CALL_IN_PROGRESS, true);
    config.timeout = 15000;
    // const token = getStorage('token');
    // if (token) {
    //   config.headers.common.Authorization = `Bearer ${token}`;
    // }
    return config;
  },
  response => Promise.reject(response)
);

HTTPClient.interceptors.response.use(
  response => {
    store.commit(SET_API_CALL_IN_PROGRESS, false);
    return response;
  },
  error => {
    store.commit(SET_API_CALL_IN_PROGRESS, false);
    return Promise.reject(error);
  }
);

export { HTTPClient };
